import { createContext, useCallback, useContext, useState } from "react";

const ConsultationContext = createContext(null);

export const ConsultationProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [presetService, setPresetService] = useState("");

  const openConsultation = useCallback((service = "") => {
    setPresetService(service);
    setOpen(true);
  }, []);

  const closeConsultation = useCallback(() => setOpen(false), []);

  return (
    <ConsultationContext.Provider value={{ open, presetService, openConsultation, closeConsultation, setOpen }}>
      {children}
    </ConsultationContext.Provider>
  );
};

export const useConsultation = () => useContext(ConsultationContext);
